export const SET_MXD = 'SET_MXD'
export const HIDE_COOKIES_INFO = 'HIDE_COOKIES_INFO'

const intialState = {
  // mxd = Mixpanel Distinct Id
  mxd: null,
  // If the cookies info should be hidden
  showCookieInfoBar: true
}

export default function analytics (state = intialState, action) {
  switch (action.type) {
    case SET_MXD:
      return { ...state, mxd: action.mxd }
    case HIDE_COOKIES_INFO:
      return { ...state, showCookieInfoBar: false }
    default:
      return state
  }
}

export function setMxd (mxd) {
  return {
    type: SET_MXD,
    mxd
  }
}

export function hideCookiesInfo () {
  return {
    type: HIDE_COOKIES_INFO
  }
}
